<template>
  <footer class="text-center sd-footer" :class="user.sub_branch == '2' || user.branch == 3 ? 'advanced-education' : ''">
    <template v-if="user.type == 2">
      <div class="menu-item dashboard">
        <router-link :to="{ name: 'company-dashboard' }">
        <span class="icon-container">
          <svg-icon icon="home" />
        </span>
          <span class="menu-item-text">Dashboard</span>
        </router-link>
      </div>
      <div class="menu-item recommendations">
          <template v-if="user.branch == 3">
              <router-link
                  :to="{ name: 'company-healthcare-matches' }"
              >
                    <span class="icon-container">
                        <svg-icon icon="heart" />
                        <span class="notif" v-if="counts.matches_total > 0"><!--{{ counts.matches_total }}--></span>
                    </span>
                <span class="menu-item-text">Matches</span>
              </router-link>
          </template>
          <template v-else>
              <router-link
                  :to="{ name: 'company-matches' }"
              >
          <span class="icon-container">
            <svg-icon icon="heart" />
            <span class="notif" v-if="counts.matches_total > 0"><!--{{ counts.matches_total }}--></span>
          </span>
                  <span class="menu-item-text">Matches</span>
              </router-link>
          </template>
      </div>
      <div class="menu-item applications">
        <router-link
            :to="{ name: 'company-applicants' }"
        >
        <span class="icon-container">
          <svg-icon icon="suitcase" />
          <span class="notif" v-if="counts.applicants_total > 0"><!--{{ counts.applicants_total }}--></span>
        </span>
          <span class="menu-item-text">Sollicitaties</span>
        </router-link>
      </div>
      <div class="menu-item confirmed" v-if="user.sub_branch !== '2' && user.branch != 3">
        <router-link
            :to="{ name: 'jobs-closed' }"
        >
        <span class="icon-container">
          <svg-icon icon="checkmark_circle" />
          <span class="notif" v-if="counts.closed_total > 0"><!--{{ counts.closed_total }}--></span>
        </span>
          <span class="menu-item-text">Bevestigd</span>
        </router-link>
      </div>
      <div class="menu-item vacancies">
        <router-link
            :to="{ name: 'jobs-open' }"
        >
        <span class="icon-container">
          <svg-icon icon="calendar" />
        </span>
          <span class="menu-item-text">Vacatures</span>
        </router-link>
      </div>
    </template>
    <template v-else>
      <div class="menu-item dashboard">
        <router-link :to="{ name: 'applicant-dashboard' }">
        <span class="icon-container">
          <svg-icon icon="home" />
        </span>
          <span class="menu-item-text">Dashboard</span>
        </router-link>
      </div>
      <div class="menu-item matches">
        <router-link
            :to="{ name: 'jobs-match' }"
        >
        <span class="icon-container">
          <svg-icon icon="heart" />
          <span class="notif" v-if="counts.matches_total > 0"><!--{{ counts.matches_total }}--></span>
        </span>
          <span class="menu-item-text">Matches</span>
        </router-link>
      </div>
      <div class="menu-item applications">
        <router-link
            :to="{ name: 'jobs-pending' }"
        >
        <span class="icon-container">
          <svg-icon icon="suitcase" />
          <span class="notif" v-if="counts.applied_total > 0"><!--{{ counts.applied_total }}--></span>
        </span>
          <span class="menu-item-text">Sollicitaties</span>
        </router-link>
      </div>
      <div class="menu-item confirmed" v-if="user.sub_branch !== '2' && user.branch != 3">
        <router-link
            :to="{ name: 'jobs-approved' }"
        >
        <span class="icon-container">
          <svg-icon icon="checkmark_circle" />
          <span class="notif" v-if="counts.approved_total > 0"><!--{{ counts.approved_total }}--></span>
        </span>
          <span class="menu-item-text">Bevestigd</span>
        </router-link>
      </div>
      <div class="menu-item availability">
        <router-link
            :to="{ name: 'availability' }"
        >
        <span class="icon-container">
          <svg-icon icon="calendar" />
          <span v-if="!searchAvailabilityStillCurrent() && !user.healthcare_availability" class="warning"><!--!--></span>
        </span>
          <span class="menu-item-text">Beschikbaarheid</span>
        </router-link>
      </div>
    </template>
  </footer>
</template>

<script>
export default {
  data: function() {
    return {
      route: window.location.href,
      user_token: "",
      user: "",
      counts: {}
    };
  },
  props: {
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    navState: async function() {
      await this.fetchData();
    },
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.user_token = JSON.parse(localStorage.getItem("user-token"));
      this.user = JSON.parse(localStorage.getItem("user"));

      if (this.user_token == null)
        this.user_token = "";

      if (this.user == null)
        this.user = "";

      if (this.user)
        this.$store.state.user_avatar = this.user.avatar;

      if (localStorage.getItem("dashboard") !== null) {
        this.counts = JSON.parse(localStorage.getItem("dashboard"));
      } else {
        if(this.user.type == 2)
          this.counts = await this.getTokenAPIList("company/dashboard");
        else
          this.counts = await this.getTokenAPIList("applicant/dashboard");
      }
    },
    searchAvailabilityStillCurrent() {
      if (this.user.search_availability) {
        var dates = JSON.parse(this.user.search_availability);

        if(Array.isArray(dates))
          var lastDate = dates.pop();
        else
          var lastDate = dates[Object.keys(dates)[Object.keys(dates).length - 1]];

        return new Date(lastDate).getTime() > (new Date().getTime() - (24 * 60 * 60 * 1000));
      }
    }
  },
  created: function() {
  }
};
</script>

<style scoped>

.sd-footer .menu-item a.router-link-active .icon-container,
.sd-footer .menu-item a:hover .icon-container {
  color: #FFCD00;
}
</style>
